<template>
  <v-container>
    <v-row class="text-h1">
      Repository Actions
    </v-row>
    <v-row>
      <v-col>
        <LoadEntries />
      </v-col>
      <v-col>
        <CommitEntries />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import LoadEntries from "@/components/repository/LoadEntries";
import CommitEntries from "@/components/repository/CommitEntries";

export default {
  name: "RepositoryView",
  components: {
    CommitEntries,
    LoadEntries
  }
};
</script>
